import React from 'react'

class Icon extends React.Component {
  render() {
    const { width, height, color, icon } = this.props
    const svg = {
      bug: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            viewBox="0 0 24 24">
            <path d="M24 20.586l-2.831-2.832c.522-.79.831-1.735.831-2.754 0-2.761-2.238-5-5-5s-5 2.239-5 5 2.238 5 5 5c1.019 0 1.964-.309 2.755-.832l2.831 2.832 1.414-1.414zm-10-5.586c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3zm-8.105-11.827c0-.647.535-1.173 1.193-1.173.784 0 1.354.736 1.149 1.48-.077.281-.035.58.117.829.333.553.902.895 1.646.899.733-.004 1.31-.341 1.647-.898.151-.25.193-.548.116-.829-.205-.744.364-1.481 1.149-1.481.66 0 1.191.526 1.191 1.173 0 .564-.4 1.029-.932 1.146-.267.059-.498.224-.641.456-.508.848.162 1.599.777 2.354-1.008.468-2.102.705-3.307.705-1.222 0-2.309-.232-3.312-.701.623-.767 1.295-1.501.779-2.358-.141-.231-.372-.397-.64-.456-.53-.117-.932-.582-.932-1.146zm4.105 11.827c0 2.432 1.249 4.577 3.137 5.832-.854.59-1.904 1.03-3.137 1.168-2.492-.278-4.243-1.788-5.113-3.286-.177-.304-.494-.329-.751-.216l-2.133.952c-.441.196-.962.002-1.162-.433-.2-.435-.004-.947.438-1.144l2.017-.898c.436-.195.719-.611.625-1.217-.088-.571-.577-.882-1.054-.882h-1.989c-.486 0-.878-.386-.878-.863 0-.478.392-.865.878-.865h2.002c.46 0 .941-.294 1.03-.925.068-.483-.232-.902-.645-1.062l-1.86-.723c-.45-.175-.672-.676-.494-1.12.178-.444.689-.663 1.139-.487l1.913.742c.245.095.594.064.784-.365.15-.339.32-.655.501-.954 1.423.831 2.99 1.246 4.752 1.246 1.412 0 2.723-.297 3.933-.848l.04.056c-2.344 1.131-3.973 3.519-3.973 6.292z" />
          </svg>
        )
      },
      copyToClipboard: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 14.6"
            width={width ? width : 18}
            height={height ? height : 14.5}>
            <g id="Copy" transform="translate(-310 -524)">
              <path
                id="Path_1683"
                d="M14.1 4.1V0H0v10.5h3.9v4.1H18V4.1zm-13 5.4V1.1h12v8.4h-12zm15.8-4.3v8.4H5v-3.1h9.2V5.2z"
                className="cls-1"
                fill={color ? color : '#124b5f'}
                data-name="Path 1683"
                transform="translate(310 524)"
              />
            </g>
          </svg>
        )
      },
      filter: () => {
        return (
          <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={width ? width : 18}
            height={height ? height : 16.5}
            viewBox="0 0 971.986 971.986">
            <g>
              <path
                fill={color ? color : '#124b5f'}
                d="M370.216,459.3c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3
		c16.5-19.8,25.6-29.601,25.6-49.2V500c0-15,5.7-29.5,15.8-40.601L955.615,75.5c26.5-28.8,6.101-75.5-33.1-75.5h-873
		c-39.2,0-59.7,46.6-33.1,75.5L370.216,459.3z"
              />
            </g>
          </svg>
        )
      },
      editList: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18.492 18.631"
            width={width ? width : 18.492}
            height={height ? height : 18.631}>
            <g id="Edit-list" transform="translate(-81.4 -127.23)">
              <path
                id="Path_1667"
                d="M15.7 10.252V17.3H.5V2.1h6.494"
                className="cls-1"
                fill="none"
                stroke="#124b5f"
                strokeMiterlimit="10"
                strokeWidth="1.2px"
                data-name="Path 1667"
                transform="translate(81.5 127.963)"
              />
              <g id="Group_1558" data-name="Group 1558" transform="translate(86.007 127.23)">
                <g id="Group_1557" data-name="Group 1557">
                  <path
                    id="Path_1668"
                    d="M3.4 10.482v2.9a.489.489 0 0 0 .553.553h2.9a.508.508 0 0 0 .415-.138l9.81-9.81a.518.518 0 0 0 0-.829L14.315.257a.518.518 0 0 0-.829 0l-1.934 1.935-7.876 7.875c-.138.138-.276.276-.276.415zM13.9 1.5l1.934 1.934-1.104 1.107-1.93-1.935zm-9.256 9.258l7.323-7.323L13.9 5.37l-7.184 7.323H4.782l-.138-1.934z"
                    className="cls-2"
                    data-name="Path 1668"
                    fill={color ? color : '#124b5f'}
                    transform="translate(-3.4 -.05)"
                  />
                </g>
              </g>
            </g>
          </svg>
        )
      },
      addToList: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="product"
            viewBox="0 0 19.5 18"
            width={width ? width : 19.5}
            height={height ? height : 18}>
            <g id="Group-4">
              <path
                id="Shape"
                d="M11.417 19.5a.715.715 0 0 0 .75-.675v-3.15a.754.754 0 0 0-1.5 0v3.15a.715.715 0 0 0 .75.675z"
                className="cls-1"
                fill={color ? color : '#078489'}
                fillRule="evenodd"
                transform="translate(-2.987 -4.342)"
              />
              <path
                id="Shape-2"
                d="M15.083 19.5a.715.715 0 0 0 .75-.675v-3.15a.754.754 0 0 0-1.5 0v3.15a.715.715 0 0 0 .75.675z"
                className="cls-1"
                fill={color ? color : '#078489'}
                fillRule="evenodd"
                data-name="Shape"
                transform="translate(-4.013 -4.342)"
              />
              <path
                id="Shape-3"
                d="M18.75 19.5a.715.715 0 0 0 .75-.675v-3.15a.754.754 0 0 0-1.5 0v3.15a.715.715 0 0 0 .75.675z"
                className="cls-1"
                fill={color ? color : '#078489'}
                fillRule="evenodd"
                data-name="Shape"
                transform="translate(-5.04 -4.342)"
              />
              <path
                id="Shape-4"
                d="M7.75 19.5a.715.715 0 0 0 .75-.675v-3.15a.754.754 0 0 0-1.5 0v3.15a.715.715 0 0 0 .75.675z"
                className="cls-1"
                fill={color ? color : '#078489'}
                fillRule="evenodd"
                data-name="Shape"
                transform="translate(-1.96 -4.342)"
              />
              <path
                id="Shape-5"
                d="M18.194 4.742h-.844v-.027L12.948.184a.653.653 0 0 0-.925.016.7.7 0 0 0-.016.952l3.487 3.589H4.033L7.52 1.153A.7.7 0 0 0 7.5.2a.653.653 0 0 0-.922-.016l-4.4 4.531v.027h-.845A1.352 1.352 0 0 0 0 6.114v1.828a1.352 1.352 0 0 0 1.333 1.372 1.411 1.411 0 0 0 0 .251l1.332 7.315A1.343 1.343 0 0 0 3.976 18h11.548a1.343 1.343 0 0 0 1.31-1.12l1.333-7.315a1.411 1.411 0 0 0 0-.251A1.352 1.352 0 0 0 19.5 7.942V6.114a1.353 1.353 0 0 0-1.306-1.372zm-2.665 11.886H3.98L2.647 9.314h14.215zm2.665-8.686H1.315V6.114h16.879z"
                className="cls-1"
                fill={color ? color : '#078489'}
                fillRule="evenodd"
                data-name="Shape"
              />
            </g>
          </svg>
        )
      },
      trash: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18.08 19.395"
            width={width ? width : 18.08}
            height={height ? height : 19.395}>
            <g id="Delete" transform="translate(-340.9 -53)">
              <path
                id="Path_1665"
                d="M146.875 175l-.33 8.989 1.519.057.33-8.989zm-2.936.027v8.989h1.519v-8.986zm-1.421-.03l-1.519.057.33 8.989 1.519-.057zm0 0l-1.519.057.33 8.989 1.519-.057zm1.421.03v8.989h1.519v-8.986zm2.936-.027l-.33 8.989 1.519.057.33-8.989zm-4.356 0l-1.519.057.33 8.989 1.519-.057zm1.421.03v8.989h1.519v-8.989zm2.936-.027l-.33 8.989 1.519.057.33-8.989z"
                fill={color ? color : '#fff'}
                className="cls-1"
                data-name="Path 1665"
                transform="translate(205.241 -115.371)"
              />
              <path
                id="Path_1666"
                d="M12.784 2.913V1.265A1.267 1.267 0 0 0 11.519 0H6.557a1.267 1.267 0 0 0-1.265 1.265v1.648H0v1.519h1.583L2.841 18.7a.762.762 0 0 0 .758.693h10.86a.762.762 0 0 0 .758-.693L16.47 4.432h1.61V2.913zM6.811 1.519h4.455v1.394H6.811zm6.951 16.357h-9.47L3.106 4.432h11.838z"
                fill={color ? color : '#fff'}
                className="cls-1"
                data-name="Path 1666"
                transform="translate(340.9 53)"
              />
            </g>
          </svg>
        )
      },
      arrowBack: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 23.414}
            height={height ? height : 18.924}
            viewBox="0 0 23.414 18.924">
            <g id="Back" transform="translate(-9.957 -57.793)">
              <path
                id="Line_3"
                d="M0 0h21.012"
                className="cls-1"
                fill={'none'}
                stroke={color ? color : '#124b5f'}
                strokeWidth="2"
                data-name="Line 3"
                transform="translate(12.359 67.255)"
              />
              <path
                id="Path_1153"
                d="M4030.126 894.5l-8.755 8.755 8.755 8.755"
                className="cls-1"
                fill={'none'}
                stroke={color ? color : '#124b5f'}
                strokeWidth="2"
                data-name="Path 1153"
                transform="translate(-4010 -836)"
              />
            </g>
          </svg>
        )
      },
      showEye: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            viewBox="0 0 24 24">
            <g id="baseline-remove_red_eye-24px" transform="translate(-309 -204)">
              <path
                id="Path_1081"
                d="M0 0h24v24H0z"
                className="cls-1"
                fill="none"
                data-name="Path 1081"
                transform="translate(309 204)"
              />
              <path
                id="Path_1082"
                d="M12 4.5A11.827 11.827 0 0 0 1 12a11.817 11.817 0 0 0 22 0 11.827 11.827 0 0 0-11-7.5zM12 17a5 5 0 1 1 5-5 5 5 0 0 1-5 5zm0-8a3 3 0 1 0 3 3 3 3 0 0 0-3-3z"
                className="cls-2"
                fill={color ? color : '#124b5f'}
                data-name="Path 1082"
                transform="translate(309 204)"
              />
            </g>
          </svg>
        )
      },
      email: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 14}
            height={height ? height : 10.705}
            viewBox="0 0 14 10.705">
            <path
              d="M0 0v10.706h14V0zm4.859 6.588L7 8.318l2.141-1.73 3.376 3.294H1.482zM.824 9.306V3.294l3.376 2.8C4.2 6.012.824 9.306.824 9.306zM9.8 6.012l3.376-2.718v6.012zM13.176.824v1.317L7 7.247.824 2.224v-1.4z"
              data-name="Path 1088"
            />
          </svg>
        )
      },
      facebook: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 7.5}
            height={height ? height : 14.4}
            viewBox="0 0 7.5 14.4">
            <path
              id="Path_1087"
              d="M4.8 3.6v1.8h2.7L6.9 8H4.8v6.4H2.1V8H0V5.4h2.1V3.3A3.075 3.075 0 0 1 5.5 0c.9 0 1.7.1 2 .1v2.3H6.1c-1.1 0-1.3.5-1.3 1.2z"
              className="cls-1"
              fill="#39579a"
              data-name="Path 1087"
            />
          </svg>
        )
      },
      google: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 16.699}
            height={height ? height : 17}
            viewBox="0 0 16.699 17">
            <g id="Group_516" data-name="Group 516">
              <path
                id="Path_1083"
                d="M16.7 8.7a8.807 8.807 0 0 0-.2-1.7h-8v3.3h4.6a3.9 3.9 0 0 1-1.7 2.6V15h2.7a8.5 8.5 0 0 0 2.6-6.3z"
                className="cls-1"
                fill="#4285f4"
                data-name="Path 1083"
              />
              <path
                id="Path_1084"
                d="M8.5 17a8.047 8.047 0 0 0 5.6-2.1l-2.7-2.1a5.212 5.212 0 0 1-7.7-2.7H.9v2.2A8.438 8.438 0 0 0 8.5 17z"
                className="cls-2"
                fill="#34a853"
                data-name="Path 1084"
              />
              <path
                id="Path_1085"
                d="M3.7 10.1a7.772 7.772 0 0 1-.2-1.6 4.146 4.146 0 0 1 .3-1.6V4.7H.9A8.489 8.489 0 0 0 0 8.5a7.9 7.9 0 0 0 .9 3.8z"
                className="cls-3"
                fill="#fbbc05"
                data-name="Path 1085"
              />
              <path
                id="Path_1086"
                d="M8.5 3.4a4.224 4.224 0 0 1 3.2 1.3l2.4-2.4A7.381 7.381 0 0 0 8.5 0 8.438 8.438 0 0 0 .9 4.7l2.8 2.2a5.174 5.174 0 0 1 4.8-3.5z"
                className="cls-4"
                fill="#ea4335"
                data-name="Path 1086"
              />
            </g>
          </svg>
        )
      },
      search: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 17}
            height={height ? height : 17}
            id="search"
            viewBox="0 0 17 17">
            <defs>
              <clipPath id="clip-path">
                <path
                  id="Combined_Shape"
                  d="M12.957 13.959l-3.211-3.211a6.027 6.027 0 1 1 1-1l3.212 3.211a.709.709 0 0 1-1 1zM1.417 6.021A4.6 4.6 0 0 0 9.25 9.3l.024-.025.026-.025a4.6 4.6 0 1 0-7.883-3.23z"
                  data-name="Combined Shape"
                />
              </clipPath>
            </defs>
            <path
              id="search_background"
              d="M0 0h17v17H0z"
              className="cls-1"
              fill="rgba(0,0,0,0)"
              data-name="search background"
            />
            <path
              id="Combined_Shape-2"
              d="M12.957 13.959l-3.211-3.211a6.027 6.027 0 1 1 1-1l3.212 3.211a.709.709 0 0 1-1 1zM1.417 6.021A4.6 4.6 0 0 0 9.25 9.3l.024-.025.026-.025a4.6 4.6 0 1 0-7.883-3.23z"
              className="cls-2"
              fill="#124b5f"
              data-name="Combined Shape"
              transform="translate(1.417 1.417)"
            />
          </svg>
        )
      },
      group: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Group"
            width={width ? width : 20.809}
            height={height ? height : 19}
            viewBox="0 0 20.809 19">
            <g id="Human-Rights">
              <g id="Group-2" data-name="Group">
                <g id="User" transform="translate(5.429)">
                  <path
                    id="Shape"
                    d="M5.429 11.762a5.675 5.675 0 0 0 5.429-5.881A5.675 5.675 0 0 0 5.429 0 5.675 5.675 0 0 0 0 5.881a5.679 5.679 0 0 0 5.429 5.881zm0-10.292c2.1 0 3.8 1.96 3.8 4.411s-1.7 4.411-3.8 4.411-3.8-1.96-3.8-4.411 1.699-4.411 3.8-4.411z"
                    className="cls-1"
                    fillRule="evenodd"
                    fill={color ? color : '#124b5f'}
                  />
                </g>
                <path
                  id="Shape-2"
                  d="M15.049 13a.756.756 0 0 0-.837.652.738.738 0 0 0 .685.8 4.813 4.813 0 0 1 4.354 4.348H1.558a4.852 4.852 0 0 1 4.355-4.344.738.738 0 0 0 .685-.8.756.756 0 0 0-.837-.656C5.7 13 0 13.621 0 19.514a.743.743 0 0 0 .761.724h19.287a.743.743 0 0 0 .761-.724C20.81 13.621 15.1 13 15.049 13z"
                  className="cls-1"
                  fillRule="evenodd"
                  fill={color ? color : '#124b5f'}
                  data-name="Shape"
                  transform="translate(0 -1.238)"
                />
              </g>
            </g>
          </svg>
        )
      },
      environment: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 22.619}
            height={height ? height : 18.99}
            viewBox="0 0 22.619 18.99">
            <g id="Enviroment" transform="translate(0 -.334)">
              <g id="Enviroment-2" data-name="Enviroment" transform="translate(0 .333)">
                <g id="Mountains">
                  <path
                    id="Shape"
                    d="M22.488 16.936l-4.078-8.76a1.534 1.534 0 0 0-1.4-.866 1.534 1.534 0 0 0-1.4.866l-.382.818L12.345.983a1.554 1.554 0 0 0-2.89 0L7.5 6.394l-.26-.686a1.555 1.555 0 0 0-2.875 0L.087 17.043a1.405 1.405 0 0 0 .192 1.328 1.552 1.552 0 0 0 1.245.619h19.567a1.548 1.548 0 0 0 1.282-.665 1.4 1.4 0 0 0 .114-1.389zM10.9 1.469l3.425 9.485-2.785 5.982a1.4 1.4 0 0 0-.122.594H5.1zM5.8 6.214L6.7 8.6l-3.055 8.453a1.4 1.4 0 0 0-.071.487H1.535zm7.136 11.316l4.077-8.76 4.077 8.76z"
                    className="cls-1"
                    fillRule="evenodd"
                    fill={color ? color : '#124b5f'}
                  />
                  <path
                    id="Shape-2"
                    d="M22.712 6.2a2.431 2.431 0 1 0-2.462-2.435A2.447 2.447 0 0 0 22.712 6.2zm0-3.4a.973.973 0 1 1-.985.972.979.979 0 0 1 .985-.98z"
                    className="cls-1"
                    fillRule="evenodd"
                    fill={color ? color : '#124b5f'}
                    data-name="Shape"
                    transform="translate(-3.784 -.118)"
                  />
                </g>
              </g>
            </g>
          </svg>
        )
      },
      foot: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Animal Welfare"
            width={width ? width : 23.281}
            height={height ? height : 19.971}
            viewBox="0 0 23.281 19.971">
            <path
              d="M15.569 10.683a5.727 5.727 0 0 0-9.546 0l-2.524 3.866a3.471 3.471 0 0 0 .293 4.19 3.577 3.577 0 0 0 1.928 1.145 3.627 3.627 0 0 0 2.244-.21l.046-.02a7.176 7.176 0 0 1 5.618.02 3.626 3.626 0 0 0 1.44.3 3.679 3.679 0 0 0 .8-.089 3.577 3.577 0 0 0 1.929-1.145 3.472 3.472 0 0 0 .294-4.19zm1.194 7.185a2.239 2.239 0 0 1-2.585.58 8.567 8.567 0 0 0-6.762 0l-.031.013a2.239 2.239 0 0 1-2.556-.592 2.139 2.139 0 0 1-.182-2.6l2.525-3.865a4.349 4.349 0 0 1 7.248 0l2.525 3.87a2.139 2.139 0 0 1-.182 2.594z"
              data-name="Path 1528"
              fill={color ? color : '#124b5f'}
            />
            <path
              d="M4.179 10.678a2.724 2.724 0 0 0 1.606-1.673 3.43 3.43 0 0 0-.063-2.407 3.512 3.512 0 0 0-1.6-1.826 2.8 2.8 0 0 0-2.334-.184A3.07 3.07 0 0 0 .249 8.667a3.319 3.319 0 0 0 2.99 2.182 2.65 2.65 0 0 0 .94-.171zM1.522 8.186a1.751 1.751 0 0 1 .76-2.348 1.287 1.287 0 0 1 .457-.082 1.562 1.562 0 0 1 .735.194 2.163 2.163 0 0 1 .976 1.131 2.113 2.113 0 0 1 .05 1.48 1.4 1.4 0 0 1-.809.867 1.8 1.8 0 0 1-2.169-1.242z"
              data-name="Path 1529"
              fill={color ? color : '#124b5f'}
            />
            <path
              d="M9.077 7.649a3.643 3.643 0 0 0 3.42-3.824A3.644 3.644 0 0 0 9.077 0a3.644 3.644 0 0 0-3.42 3.825 3.643 3.643 0 0 0 3.42 3.824zm0-6.31a2.3 2.3 0 0 1 2.055 2.486A2.3 2.3 0 0 1 9.077 6.31a2.3 2.3 0 0 1-2.055-2.485 2.3 2.3 0 0 1 2.055-2.486z"
              data-name="Path 1530"
              fill={color ? color : '#124b5f'}
            />
            <path
              d="M14.984 8.589a2.835 2.835 0 0 0 .881.14 3.534 3.534 0 0 0 3.226-2.489 3.686 3.686 0 0 0-.055-2.587 2.924 2.924 0 0 0-1.8-1.711 3 3 0 0 0-2.486.312 3.762 3.762 0 0 0-1.621 2.041 3.3 3.3 0 0 0 1.855 4.294zm-.559-3.875a2.419 2.419 0 0 1 1.033-1.317 1.631 1.631 0 0 1 1.348-.187 1.591 1.591 0 0 1 .966.942 2.37 2.37 0 0 1 .025 1.662 2.031 2.031 0 0 1-2.385 1.504 1.977 1.977 0 0 1-.988-2.604z"
              data-name="Path 1531"
              fill={color ? color : '#124b5f'}
            />
            <path
              d="M22.185 8.143a3.19 3.19 0 0 0-4.336.911 3.054 3.054 0 0 0 .379 4.334 2.708 2.708 0 0 0 1.606.509 3.477 3.477 0 0 0 2.735-1.42 3.055 3.055 0 0 0-.384-4.334zm-.716 3.538a1.82 1.82 0 0 1-2.427.631 1.744 1.744 0 0 1-.094-2.461 2.106 2.106 0 0 1 1.621-.88 1.35 1.35 0 0 1 .8.25 1.744 1.744 0 0 1 .1 2.46z"
              data-name="Path 1532"
              fill={color ? color : '#124b5f'}
            />
          </svg>
        )
      },
      shield: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Group12"
            width={width ? width : 19}
            height={height ? height : 22}
            viewBox="0 0 19 22">
            <g id="Health-Safety">
              <g id="Group">
                <g id="Security_announcement">
                  <path
                    id="Shape"
                    d="M18.955 3.138C18.66 1.967 17.045 0 9.5 0 5.945 0 3.365.39 1.83 1.161.135 2.012 0 3.163 0 3.5v6.66a11.514 11.514 0 0 0 5.86 10.01l2.905 1.637a1.5 1.5 0 0 0 1.47 0l2.905-1.637A11.514 11.514 0 0 0 19 10.16V3.5a1.5 1.5 0 0 0-.045-.362zM17.5 10.145a10.012 10.012 0 0 1-5.1 8.724l-2.9 1.652-2.905-1.637A10.012 10.012 0 0 1 1.5 10.16V3.5s0-2 8-2c7.5 0 8 2 8 2z"
                    className="cls-1"
                    fillRule="evenodd"
                    fill={color ? color : '#124b5f'}
                  />
                </g>
                <circle
                  id="Oval"
                  cx="1"
                  cy="1"
                  r="1"
                  transform="translate(8.5 15.5)"
                  fill={color ? color : '#124b5f'}
                />
                <path
                  id="Shape-2"
                  d="M9.5 5c-.276 0-.5.318-.5.711v7.579c0 .392.224.711.5.711s.5-.318.5-.711V5.711C10 5.318 9.776 5 9.5 5z"
                  className="cls-1"
                  fillRule="evenodd"
                  fill={color ? color : '#124b5f'}
                  data-name="Shape"
                />
              </g>
            </g>
          </svg>
        )
      },
      food: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24.9}
            height={height ? height : 20.145}
            viewBox="0 0 24.9 20.145">
            <path
              d="M14.139 5.506a6.1 6.1 0 0 1 .375-.876c-.125.125-.25.25-.375.25 0-.375.125-.751.125-1.126a2.618 2.618 0 0 1-.5.751c-.125-.5-.125-1-.25-1.5v3.376h.375c.125 0 .125 0 .25-.125.125-.25.375-.626.5-.876l.125-.125c-.249.125-.375.125-.625.251zM21.522.751c-.25-.125-.25-.125-.375 0a19.86 19.86 0 0 1-.876 2.5 22.827 22.827 0 0 0-.876 3.128 1.128 1.128 0 0 1-.125.626c.876-2 1.5-4 2.252-6.131.125-.123.125-.123 0-.123zm-4.63 2c-.125.125-.25.375-.5.5.125-.5.125-1 .25-1.376a2.618 2.618 0 0 1-.5.751L15.766.375c0 .5-.125 1.126-.125 1.627-.125-.125-.25-.375-.375-.5.25 1 .5 2 .751 3.128-.125.375-.125.375.25.375.125 0 .125 0 .125-.125l.375-1.5c0-.25.125-.375.125-.626zM0 7.508a2.787 2.787 0 0 0 3.629.876A2.713 2.713 0 0 0 0 7.508zm14.64-.25a.773.773 0 0 0-1-.626.123.123 0 0 0-.125.125v3.253c0 .125 0 .125.125.125h.626c.125 0 .125 0 .125-.125a7.323 7.323 0 0 1 .25-1.627 1.725 1.725 0 0 0-.001-1.126zM4.129 3.629a2.759 2.759 0 0 0 0 4.379 2.839 2.839 0 0 0 0-4.379zm2.377 4.63a2.07 2.07 0 0 0-2.377 0 2.206 2.206 0 0 0-1 1.877h4.379a2.344 2.344 0 0 0-1.001-1.878zm10.636-2.5a.686.686 0 0 0-.751-.5.686.686 0 0 0-.751.5.752.752 0 0 0-.125.5 10.114 10.114 0 0 0-.125 2c0 .626.125 1.251.125 1.752 0 .125 0 .125.125.125h1.251c.125 0 .125 0 .125-.125a9.659 9.659 0 0 1 .25-1.877c0-.5.125-1 .125-1.376a1.938 1.938 0 0 0-.249-1.002zm7.758-.25c-.125-.25-.25-.626-.375-.876A1.508 1.508 0 0 0 23.9 4c-.626.751-1.126 1.627-1.752 2.377a35.432 35.432 0 0 0-2.5 3.5.123.123 0 0 1-.125.125h1.251c.125 0 .25 0 .25-.125A21.629 21.629 0 0 1 24.9 5.506c0 .125 0 0 0 0zM22.272.375c-.125.375-.375.626-.375 1l-1.126 3c-.375.876-.626 1.877-1 2.628a7.953 7.953 0 0 0-.751 2.252 2.32 2.32 0 0 1-.25.876h.375c.125 0 .125 0 .25-.125 1.376-2.628 2.753-5.38 4-8.133l.375-.751a8.331 8.331 0 0 1-1.498-.747zM20.02.125A7.7 7.7 0 0 1 18.268 0a.123.123 0 0 0-.125.125c-.125 1.752-.25 3.629-.375 5.38-.125 1.376-.25 2.753-.375 4v.5h1c.125 0 .125 0 .25-.125.25-1.376.626-2.628.876-4 .25-1.5.5-3 .626-4.63A3.107 3.107 0 0 1 20.02.125zm-9.635 6.757v-.125C9.76 5.38 9.134 4 8.383 2.628A8.033 8.033 0 0 0 7.132 1a2.2 2.2 0 0 0-.625-.5c-.25-.125-.5 0-.5.25 0 .125-.125.375-.125.5a4.77 4.77 0 0 0 .125 1.877c.25 1.376.626 2.628 1 4 .375 1 .751 1.877 1.126 2.878 0 .125.125.125.25.125h2V6.882zm-2.752-.751c0 .125-.125.25-.125.375l-.125.125-.125-.125v-.25a7.132 7.132 0 0 1 .5-2.753.437.437 0 0 1 .125-.25l.125-.125.125.125v.5a13.29 13.29 0 0 1-.5 2.378zm1.752.375a9.746 9.746 0 0 1-.5 2.628c0 .125-.125.25-.125.375a.123.123 0 0 1-.125.125c0-.125-.125-.125-.125-.25v-.25a7.976 7.976 0 0 1 .5-3c0-.125.125-.125.125-.25l.125-.125.125.125v.626zm11.512 4h-7.634c-.125 0-.125 0-.125-.125V4.5a.591.591 0 0 0-.626-.626h-.876a.752.752 0 0 0-.5.125.949.949 0 0 0-.25.5v6.131H3.128v4.63a5.667 5.667 0 0 0 .375 2 3.374 3.374 0 0 0 1.377 1.884 6.38 6.38 0 0 0 3.629 1h7.382a6.293 6.293 0 0 0 3.378-1 2.922 2.922 0 0 0 1.251-1.5 6.355 6.355 0 0 0 .375-2.127v-4.131c.005-.5.005-.625.005-.875zm-6.758-5a6.1 6.1 0 0 1 .375-.876c-.125.125-.25.25-.375.25 0-.375.125-.751.125-1.126a2.618 2.618 0 0 1-.5.751c-.125-.5-.125-1-.25-1.5v3.376h.375c.125 0 .125 0 .25-.125.125-.25.375-.626.5-.876l.125-.125c-.249.125-.375.125-.625.251zM21.522.751c-.25-.125-.25-.125-.375 0a19.86 19.86 0 0 1-.876 2.5 22.827 22.827 0 0 0-.876 3.128 1.128 1.128 0 0 1-.125.626c.876-2 1.5-4 2.252-6.131.125-.123.125-.123 0-.123zm-4.63 2c-.125.125-.25.375-.5.5.125-.5.125-1 .25-1.376a2.618 2.618 0 0 1-.5.751L15.766.375c0 .5-.125 1.126-.125 1.627-.125-.125-.25-.375-.375-.5.25 1 .5 2 .751 3.128-.125.375-.125.375.25.375.125 0 .125 0 .125-.125l.375-1.5c0-.25.125-.375.125-.626zM0 7.508a2.787 2.787 0 0 0 3.629.876A2.713 2.713 0 0 0 0 7.508zm14.64-.25a.773.773 0 0 0-1-.626.123.123 0 0 0-.125.125v3.253c0 .125 0 .125.125.125h.626c.125 0 .125 0 .125-.125a7.323 7.323 0 0 1 .25-1.627 1.725 1.725 0 0 0-.001-1.126zM4.129 3.629a2.759 2.759 0 0 0 0 4.379 2.839 2.839 0 0 0 0-4.379zm2.377 4.63a2.07 2.07 0 0 0-2.377 0 2.206 2.206 0 0 0-1 1.877h4.379a2.344 2.344 0 0 0-1.001-1.878zm10.636-2.5a.686.686 0 0 0-.751-.5.686.686 0 0 0-.751.5.752.752 0 0 0-.125.5 10.114 10.114 0 0 0-.125 2c0 .626.125 1.251.125 1.752 0 .125 0 .125.125.125h1.251c.125 0 .125 0 .125-.125a9.659 9.659 0 0 1 .25-1.877c0-.5.125-1 .125-1.376a1.938 1.938 0 0 0-.249-1.002zm7.758-.25c-.125-.25-.25-.626-.375-.876A1.508 1.508 0 0 0 23.9 4c-.626.751-1.126 1.627-1.752 2.377a35.432 35.432 0 0 0-2.5 3.5.123.123 0 0 1-.125.125h1.251c.125 0 .25 0 .25-.125A21.629 21.629 0 0 1 24.9 5.506c0 .125 0 0 0 0zM22.272.375c-.125.375-.375.626-.375 1l-1.126 3c-.375.876-.626 1.877-1 2.628a7.953 7.953 0 0 0-.751 2.252 2.32 2.32 0 0 1-.25.876h.375c.125 0 .125 0 .25-.125 1.376-2.628 2.753-5.38 4-8.133l.375-.751a8.331 8.331 0 0 1-1.498-.747zM20.02.125A7.7 7.7 0 0 1 18.268 0a.123.123 0 0 0-.125.125c-.125 1.752-.25 3.629-.375 5.38-.125 1.376-.25 2.753-.375 4v.5h1c.125 0 .125 0 .25-.125.25-1.376.626-2.628.876-4 .25-1.5.5-3 .626-4.63A3.107 3.107 0 0 1 20.02.125zm-9.635 6.757v-.125C9.76 5.38 9.134 4 8.383 2.628A8.033 8.033 0 0 0 7.132 1a2.2 2.2 0 0 0-.625-.5c-.25-.125-.5 0-.5.25 0 .125-.125.375-.125.5a4.77 4.77 0 0 0 .125 1.877c.25 1.376.626 2.628 1 4 .375 1 .751 1.877 1.126 2.878 0 .125.125.125.25.125h2V6.882zm-2.752-.751c0 .125-.125.25-.125.375l-.125.125-.125-.125v-.25a7.132 7.132 0 0 1 .5-2.753.437.437 0 0 1 .125-.25l.125-.125.125.125v.5a13.29 13.29 0 0 1-.5 2.378zm1.752.375a9.746 9.746 0 0 1-.5 2.628c0 .125-.125.25-.125.375a.123.123 0 0 1-.125.125c0-.125-.125-.125-.125-.25v-.25a7.976 7.976 0 0 1 .5-3c0-.125.125-.125.125-.25l.125-.125.125.125v.626zm11.512 4h-7.634c-.125 0-.125 0-.125-.125V4.5a.591.591 0 0 0-.626-.626h-.876a.752.752 0 0 0-.5.125.949.949 0 0 0-.25.5v6.131H3.128v4.63a5.667 5.667 0 0 0 .375 2 3.374 3.374 0 0 0 1.377 1.884 6.38 6.38 0 0 0 3.629 1h7.382a6.293 6.293 0 0 0 3.378-1 2.922 2.922 0 0 0 1.251-1.5 6.355 6.355 0 0 0 .375-2.127v-4.131c.005-.5.005-.625.005-.875zm4-5.005c-.125-.25-.25-.626-.375-.876A1.508 1.508 0 0 0 23.9 4c-.626.751-1.126 1.627-1.752 2.377a35.432 35.432 0 0 0-2.5 3.5.123.123 0 0 1-.125.125h1.251c.125 0 .25 0 .25-.125A21.629 21.629 0 0 1 24.9 5.506c0 .125 0 0 0 0zM22.272.375c-.125.375-.375.626-.375 1l-1.126 3c-.375.876-.626 1.877-1 2.628a7.953 7.953 0 0 0-.751 2.252 2.32 2.32 0 0 1-.25.876h.375c.125 0 .125 0 .25-.125 1.376-2.628 2.753-5.38 4-8.133l.375-.751a8.331 8.331 0 0 1-1.498-.747zm-.751.375c-.25-.125-.25-.125-.375 0a19.86 19.86 0 0 1-.876 2.5 22.827 22.827 0 0 0-.876 3.128 1.128 1.128 0 0 1-.125.626c.876-2 1.5-4 2.252-6.131.126-.122.126-.122.001-.122zm-.626 9.76h-7.632c-.125 0-.125 0-.125-.125V4.5a.591.591 0 0 0-.626-.626h-.876a.752.752 0 0 0-.5.125.949.949 0 0 0-.25.5v6.131H3.128v4.63a5.667 5.667 0 0 0 .375 2 3.374 3.374 0 0 0 1.377 1.884 6.38 6.38 0 0 0 3.629 1h7.382a6.293 6.293 0 0 0 3.378-1 2.922 2.922 0 0 0 1.251-1.5 6.355 6.355 0 0 0 .375-2.127v-4.131c.005-.5.005-.625.005-.875zM20.02.125A7.7 7.7 0 0 1 18.268 0a.123.123 0 0 0-.125.125c-.125 1.752-.25 3.629-.375 5.38-.125 1.376-.25 2.753-.375 4v.5h1c.125 0 .125 0 .25-.125.25-1.376.626-2.628.876-4 .25-1.5.5-3 .626-4.63A3.107 3.107 0 0 1 20.02.125zm-2.878 5.631a.686.686 0 0 0-.751-.5.686.686 0 0 0-.751.5.752.752 0 0 0-.125.5 10.114 10.114 0 0 0-.125 2c0 .626.125 1.251.125 1.752 0 .125 0 .125.125.125h1.251c.125 0 .125 0 .125-.125a9.659 9.659 0 0 1 .25-1.877c0-.5.125-1 .125-1.376a1.938 1.938 0 0 0-.249-.999zm-.25-3c-.125.125-.25.375-.5.5.125-.5.125-1 .25-1.376a2.618 2.618 0 0 1-.5.751L15.766.375c0 .5-.125 1.126-.125 1.627-.125-.125-.25-.375-.375-.5.25 1 .5 2 .751 3.128-.125.375-.125.375.25.375.125 0 .125 0 .125-.125l.375-1.5c0-.25.125-.375.125-.626zm-2.252 4.5a.773.773 0 0 0-1-.626.123.123 0 0 0-.125.125v3.255c0 .125 0 .125.125.125h.626c.125 0 .125 0 .125-.125a7.323 7.323 0 0 1 .25-1.627 1.725 1.725 0 0 0-.001-1.126zm-.5-1.752a6.1 6.1 0 0 1 .375-.876c-.125.125-.25.25-.375.25 0-.375.125-.751.125-1.126a2.618 2.618 0 0 1-.5.751c-.125-.5-.125-1-.25-1.5v3.378h.375c.125 0 .125 0 .25-.125.125-.25.375-.626.5-.876l.125-.125c-.25.125-.376.125-.626.251zm-3.755 1.378v-.125C9.76 5.38 9.134 4 8.383 2.628A8.033 8.033 0 0 0 7.132 1a2.2 2.2 0 0 0-.625-.5c-.25-.125-.5 0-.5.25 0 .125-.125.375-.125.5a4.77 4.77 0 0 0 .125 1.877c.25 1.376.626 2.628 1 4 .375 1 .751 1.877 1.126 2.878 0 .125.125.125.25.125h2V6.882zm-2.752-.751c0 .125-.125.25-.125.375l-.125.125-.125-.125v-.25a7.132 7.132 0 0 1 .5-2.753.437.437 0 0 1 .125-.25l.125-.125.125.125v.5a13.29 13.29 0 0 1-.5 2.378zm1.752.375a9.746 9.746 0 0 1-.5 2.628c0 .125-.125.25-.125.375a.123.123 0 0 1-.125.125c0-.125-.125-.125-.125-.25v-.25a7.976 7.976 0 0 1 .5-3c0-.125.125-.125.125-.25l.125-.125.125.125v.626zM6.507 8.258a2.07 2.07 0 0 0-2.377 0 2.206 2.206 0 0 0-1 1.877h4.378a2.344 2.344 0 0 0-1.001-1.877zM4.129 3.629a2.759 2.759 0 0 0 0 4.379 2.839 2.839 0 0 0 0-4.379zM0 7.508a2.787 2.787 0 0 0 3.629.876A2.713 2.713 0 0 0 0 7.508z"
              fill={color ? color : '#124b5f'}
            />
          </svg>
        )
      },
      strawberry: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Group_19"
            data-name="Group 19"
            width={width ? width : 18.334}
            height={height ? height : 22}
            viewBox="0 0 18.334 22">
            <g id="Group-19">
              <path
                id="Shape"
                d="M9.458 20.75c-.253 0-.458-.369-.458-.825v-1.1c0-.456.205-.825.458-.825s.458.369.458.825v1.1c.001.456-.205.825-.458.825z"
                className="cls-1"
                fillRule="evenodd"
                fill={color ? color : '#124b5f'}
                transform="translate(-.75 -1.5)"
              />
              <path
                id="Shape-2"
                d="M17.563 6.316A5.176 5.176 0 0 0 14.306 4a3.6 3.6 0 0 0 .517-.483 2.878 2.878 0 0 0 .668-2.342L15.277 0h-1.219a7.3 7.3 0 0 0-4.875 1.584A7.276 7.276 0 0 0 4.307 0H3.089l-.234 1.164a2.878 2.878 0 0 0 .668 2.342 3.6 3.6 0 0 0 .517.483A5.2 5.2 0 0 0 .5 6.822a5.117 5.117 0 0 0 .058 4.511l3.939 7.808a5.244 5.244 0 0 0 9.341 0l3.939-7.808a5.1 5.1 0 0 0-.21-5.017zm-6.825-2.535l-.185-.459a3.925 3.925 0 0 0-.38-.671 5.923 5.923 0 0 1 3.9-1.207s.371 1.936-3.349 2.337zM4.307 1.449a5.923 5.923 0 0 1 3.9 1.207 3.925 3.925 0 0 0-.38.671l-.185.459c-3.72-.406-3.335-2.337-3.335-2.337zM16.5 10.7l-3.939 7.808a3.775 3.775 0 0 1-6.723 0L1.894 10.7a3.692 3.692 0 0 1 .161-3.618 3.767 3.767 0 0 1 3.188-1.771h7.883a3.767 3.767 0 0 1 3.2 1.767 3.692 3.692 0 0 1 .163 3.622z"
                className="cls-1"
                fillRule="evenodd"
                fill={color ? color : '#124b5f'}
                data-name="Shape"
              />
              <path
                id="Shape-3"
                d="M9.458 8C9.205 8 9 8.369 9 8.825v1.1c0 .456.205.825.458.825s.458-.369.458-.825v-1.1C9.917 8.369 9.711 8 9.458 8z"
                className="cls-1"
                fillRule="evenodd"
                fill={color ? color : '#124b5f'}
                data-name="Shape"
                transform="translate(-.75 -.667)"
              />
              <path
                id="Shape-4"
                d="M3.458 8C3.205 8 3 8.369 3 8.825v1.1c0 .456.205.825.458.825s.458-.369.458-.825v-1.1C3.917 8.369 3.711 8 3.458 8z"
                className="cls-1"
                fillRule="evenodd"
                fill={color ? color : '#124b5f'}
                data-name="Shape"
                transform="translate(-.25 -.667)"
              />
              <path
                id="Shape-5"
                d="M14.458 8c-.253 0-.458.369-.458.825v1.1c0 .456.205.825.458.825s.458-.369.458-.825v-1.1c0-.456-.205-.825-.458-.825z"
                className="cls-1"
                fillRule="evenodd"
                fill={color ? color : '#124b5f'}
                data-name="Shape"
                transform="translate(-1.167 -.667)"
              />
              <path
                id="Shape-6"
                d="M6.458 13c-.253 0-.458.369-.458.825v1.1c0 .456.205.825.458.825s.458-.369.458-.825v-1.1c0-.456-.205-.825-.458-.825z"
                className="cls-1"
                fillRule="evenodd"
                fill={color ? color : '#124b5f'}
                data-name="Shape"
                transform="translate(-.5 -1.083)"
              />
              <path
                id="Shape-7"
                d="M11.458 13c-.253 0-.458.369-.458.825v1.1c0 .456.205.825.458.825s.458-.369.458-.825v-1.1c.001-.456-.205-.825-.458-.825z"
                className="cls-1"
                fillRule="evenodd"
                fill={color ? color : '#124b5f'}
                data-name="Shape"
                transform="translate(-.917 -1.083)"
              />
            </g>
          </svg>
        )
      },
      eye: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Group2"
            width={width ? width : 21.4}
            height={height ? height : 16.461}
            viewBox="0 0 21.4 16.461">
            <g id="iPhone-8-Copy-5">
              <g id="Group">
                <path
                  id="Shape"
                  d="M12.5 5C10.015 5 8 6.67 8 8.731s2.015 3.731 4.5 3.731S17 10.791 17 8.731 14.985 5 12.5 5zm0 5.969a2.5 2.5 0 0 1-2.7-2.238 2.5 2.5 0 0 1 2.7-2.238 2.5 2.5 0 0 1 2.7 2.238 2.5 2.5 0 0 1-2.7 2.238z"
                  className="cls-1"
                  fillRule="evenodd"
                  fill={color ? color : '#124b5f'}
                  transform="translate(-1.8 -.5)"
                />
                <path
                  id="Shape-2"
                  d="M10.7 0C4.709 0 .783 6.247.355 6.955a2.469 2.469 0 0 0 0 2.552c.428.708 4.354 6.939 10.338 6.955s9.926-6.248 10.354-6.962a2.469 2.469 0 0 0 0-2.543C20.619 6.247 16.693 0 10.7 0zm0 14.815c-5.242 0-9.054-6.585-9.054-6.585S5.458 1.646 10.7 1.646s9.054 6.585 9.054 6.585-3.8 6.585-9.036 6.585z"
                  className="cls-1"
                  fillRule="evenodd"
                  fill={color ? color : '#124b5f'}
                  data-name="Shape"
                />
              </g>
            </g>
          </svg>
        )
      },
      home: () => {
        return (
          <svg
            version="1.1"
            id="Group_1622"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 32 31"
            width={width ? width : 32}
            height={height ? height : 31}>
            <path
              fill={color ? color : '#A0B7BF'}
              className="st0"
              d="M31.7,17.2c-0.4,0.4-1,0.4-1.4,0l-2.6-2.7v14.1c0,0.5-0.5,1-1,1h-6.9V21h-7.5v8.5H5.4c-0.5,0-1-0.5-1-1V14.4
	l-2.6,2.7c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4l15-15.4c0.4-0.4,1.1-0.4,1.4,0l15,15.4C32.1,16.1,32.1,16.8,31.7,17.2z"
            />
          </svg>
        )
      },
      lists: () => {
        return (
          <svg
            version="1.1"
            id="Group_1623"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 30 30"
            width={width ? width : 30}
            height={height ? height : 30}>
            <path
              className="st0"
              fill={color ? color : '#A0B7BF'}
              d="M30,15c0,3.5-1.2,6.9-3.5,9.6c-0.8,0.9-1.6,1.7-2.5,2.4c-5.3,4-12.7,4-18,0c-0.9-0.7-1.7-1.5-2.5-2.4
	C-0.5,19.8-1,13.2,1.7,8C2.1,7.3,2.5,6.6,3,6c0.7-0.9,1.5-1.7,2.4-2.5C8.1,1.2,11.5,0,15,0C23.3,0,30,6.7,30,15z"
            />
            <g id="Group_1629" transform="translate(2 6.001)">
              <circle id="Ellipse_394" fill="#fff" className="st1" cx="9.9" cy="18.6" r="2.4" />
              <circle id="Ellipse_395" fill="#fff" className="st1" cx="20.5" cy="18.6" r="2.4" />
              <path
                fill="#fff"
                className="st1"
                d="M22.9,9.4L9.5,15.2c-0.1,0.1-0.3,0.1-0.4,0.1c-0.7,0-1.3-0.4-1.5-1.1L5.6,6l0,0L3.9,2h-4.2
		C0.1,1.3,0.5,0.6,1,0h4.3l1.5,3.5l14.8-1.3c0.1-0.1,0.3-0.1,0.4-0.1c0.7,0,1.3,0.5,1.6,1.1L24,7.5C24.2,8.3,23.7,9.2,22.9,9.4z"
              />
            </g>
          </svg>
        )
      },
      products: () => {
        return (
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 30 30"
            width={width ? width : 30}
            height={height ? height : 30}>
            <path
              fill={color ? color : '#A0B7BF'}
              className="st0"
              d="M27.5,16.4c-0.2,0-0.3-0.1-0.3,0h-4.5c-0.4,0.9-0.9,1.8-1.5,2.8l5,5c0.2,0.4,0.4,0.8,0.3,1.1
	c0,0.3-0.2,0.6-0.5,0.7c-0.2,0.2-0.6,0.4-0.9,0.4c-0.4,0-0.7-0.1-0.9-0.4l-5-5c-0.9,0.7-1.8,1.2-2.8,1.5v4.8c0,1.5,1.2,2.7,2.7,2.7
	h8.1c1.5,0,2.7-1.2,2.7-2.7v-8.1C30,17.7,28.9,16.5,27.5,16.4z M13.1,23c-3,0-6-1.4-7.8-3.8c-0.7-1-1.1-1.9-1.4-2.8H2.6
	C1.1,16.5,0,17.6,0,19.1v8.1c0,1.5,1.2,2.7,2.7,2.7h8.1c1.5,0,2.7-1.2,2.7-2.7V23H13.1z M27.2,0h-8.1c-1.4,0-2.6,1.1-2.7,2.6v1.2
	c1.8,0.6,3.5,1.8,4.8,3.3c1.3,1.8,2,3.8,2,5.8c0,0.2,0,0.5,0,0.7h4.2c1.5,0,2.7-1.2,2.7-2.7V2.7C29.9,1.2,28.7,0,27.2,0z M13.5,2.1
	C13.3,0.9,12.2,0,10.9,0H2.7C1.2,0.1,0.1,1.2,0,2.7v8.1c0,1.3,0.9,2.4,2.1,2.7h1.3c-0.1-1.4,0.2-2.9,0.8-4.2
	c0.6-1.4,1.7-2.7,2.9-3.7c1.8-1.5,4-2.2,6.5-2.2V2.7C13.6,2.6,13.5,2.3,13.5,2.1z M18.1,8.3c-0.6-0.6-1.3-1-2.1-1.3
	c-0.7-0.3-1.5-0.5-2.2-0.5c-2-0.1-3.9,0.6-5.3,2c-1.3,1.2-2,3-2,4.8v0.4c0,0.8,0.2,1.5,0.5,2.2c1,2.6,3.5,4.2,6.3,4.2h0.4
	c0.8,0,1.5-0.2,2.2-0.5c0.9-0.3,1.6-0.8,2.3-1.5l0,0c0.6-0.6,1-1.4,1.3-2.2c0.3-0.7,0.5-1.5,0.5-2.2C20.2,11.7,19.5,9.8,18.1,8.3z
	 M19.3,13.6c0,0.7-0.2,1.3-0.5,2c-0.2,0.7-0.6,1.4-1.2,2c-0.5,0.6-1.2,1-2,1.3c-0.6,0.3-1.3,0.4-1.9,0.5h-0.4
	c-2.4,0-4.6-1.5-5.5-3.7c-0.3-0.6-0.4-1.3-0.5-2v-0.4c0-1.6,0.6-3.1,1.7-4.2s2.7-1.8,4.3-1.8c0.1,0,0.3,0,0.4,0c0.7,0,1.3,0.2,2,0.5
	C16.4,8,17,8.4,17.5,8.9C18.8,10.2,19.4,11.8,19.3,13.6z"
            />
          </svg>
        )
      },
      meals: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 28.658}
            height={height ? height : 24.406}
            viewBox="0 0 28.658 24.406">
            <path
              id="Shape"
              d="M20.682 12.164A7.17 7.17 0 0 0 25.595 9.6c2.674-2.8 3.153-6.041 1.261-8.051A3.827 3.827 0 0 0 24.025.332a7.083 7.083 0 0 0-4.888 2.538c-2.283 2.393-2.983 5.1-1.961 7.092l-2.851 2.988-3.551-3.721 1.539-1.613a1.025 1.025 0 0 0 0-1.4L6.636.266A.915.915 0 0 0 5.323.29 1.026 1.026 0 0 0 5.3 1.667l5.008 5.248-.87.912-5.324-5.578a.915.915 0 0 0-1.314.024 1.026 1.026 0 0 0-.023 1.377L8.1 9.229l-.87.912-5.639-5.909a.915.915 0 0 0-1.314.024 1.026 1.026 0 0 0-.023 1.377l6.307 6.61a.916.916 0 0 0 1.337 0l1.539-1.613 3.551 3.721-7.569 7.932a1.022 1.022 0 0 0-.272.971.97.97 0 0 0 .683.715.918.918 0 0 0 .926-.285l7.568-7.932 7.411 7.766a.918.918 0 0 0 .926.285.97.97 0 0 0 .683-.715 1.022 1.022 0 0 0-.272-.971l-7.411-7.766 2.769-2.9a3.778 3.778 0 0 0 2.252.714zm-.357-8.23a5.747 5.747 0 0 1 3.716-2.087 2.086 2.086 0 0 1 1.564.7c1.32 1.391.482 3.618-1.32 5.524a5.768 5.768 0 0 1-3.742 2.087 2.044 2.044 0 0 1-1.538-.658c-1.287-1.392-.482-3.667 1.32-5.567z"
              className="cls-1"
              fill={color ? color : '#a0b7bf'}
              stroke="#a0b7bf"
              strokeWidth={0.4}
              fillRule="evenodd"
              transform="translate(.262 .199)"
            />
          </svg>
        )
      },
      heart: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 18.685}
            height={height ? height : 16.016}
            viewBox="0 0 18.685 16.016">
            <path
              id="Path_1632"
              fill={color ? color : '#ddd'}
              d="M18.684 4.72c0 5.948-8.346 10.952-8.631 11.141a1.627 1.627 0 0 1-1.328 0C8.346 15.672 0 10.762 0 4.72v-.472A4.644 4.644 0 0 1 4.932 0c1.992 0 3.6 1.416 4.647 2.36C10.528 1.415 12.14 0 14.132 0c2.845 0 4.552 1.793 4.552 4.72z"
              className="cls-1"
              data-name="Path 1632"
              transform="translate(0 .014)"
            />
          </svg>
        )
      },
      hidden: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z" fill={color ? color : '#9a9a9a'} />
            <path
              d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
              fill="#9a9a9a"
            />
          </svg>
        )
      },
      newBug: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="30pt" height="30pt" viewBox="0 0 30 30" version="1.1">
            <path d="M 29.121094 18.355469 L 27.960938 18.355469 C 27.980469 18.648438 27.992188 18.941406 27.992188 19.234375 C 27.992188 19.53125 27.980469 19.824219 27.960938 20.113281 L 29.121094 20.113281 C 29.605469 20.113281 30 19.722656 30 19.234375 C 30 18.75 29.605469 18.355469 29.121094 18.355469 Z M 29.121094 18.355469 " />
            <path d="M 27.667969 12.9375 C 28.089844 12.695312 28.234375 12.15625 27.988281 11.734375 C 27.746094 11.316406 27.210938 11.171875 26.789062 11.414062 L 25.71875 12.03125 C 26.058594 12.515625 26.363281 13.015625 26.628906 13.539062 Z M 27.667969 12.9375 " />
            <path d="M 27.667969 25.535156 L 26.628906 24.933594 C 26.363281 25.457031 26.058594 25.957031 25.71875 26.441406 L 26.789062 27.058594 C 27.253906 27.328125 27.777344 27.105469 27.988281 26.734375 C 28.234375 26.316406 28.089844 25.777344 27.667969 25.535156 Z M 27.667969 25.535156 " />
            <path d="M 2.007812 19.234375 C 2.007812 18.941406 2.019531 18.648438 2.039062 18.355469 L 0.878906 18.355469 C 0.394531 18.355469 0 18.75 0 19.234375 C 0 19.722656 0.394531 20.113281 0.878906 20.113281 L 2.039062 20.113281 C 2.019531 19.824219 2.007812 19.53125 2.007812 19.234375 Z M 2.007812 19.234375 " />
            <path d="M 2.332031 25.535156 C 1.910156 25.777344 1.765625 26.316406 2.011719 26.734375 C 2.214844 27.09375 2.730469 27.335938 3.210938 27.058594 L 4.28125 26.441406 C 3.941406 25.957031 3.636719 25.457031 3.371094 24.933594 Z M 2.332031 25.535156 " />
            <path d="M 2.332031 12.9375 L 3.371094 13.539062 C 3.636719 13.015625 3.941406 12.515625 4.28125 12.03125 L 3.210938 11.414062 C 2.789062 11.171875 2.253906 11.316406 2.011719 11.734375 C 1.765625 12.15625 1.910156 12.695312 2.332031 12.9375 Z M 2.332031 12.9375 " />
            <path d="M 11.457031 2.34375 C 12.039062 2.054688 12.667969 1.84375 13.328125 1.730469 L 11.855469 0.257812 C 11.511719 -0.0859375 10.957031 -0.0859375 10.613281 0.257812 C 10.269531 0.601562 10.269531 1.15625 10.613281 1.5 Z M 11.457031 2.34375 " />
            <path d="M 19.386719 1.5 C 19.730469 1.15625 19.730469 0.601562 19.386719 0.257812 C 19.042969 -0.0859375 18.488281 -0.0859375 18.144531 0.257812 L 16.671875 1.730469 C 17.332031 1.84375 17.960938 2.054688 18.542969 2.34375 Z M 19.386719 1.5 " />
            <path d="M 15.5 3.386719 L 14.5 3.386719 C 11.921875 3.386719 9.800781 5.296875 9.460938 7.777344 C 11.035156 7.082031 12.753906 6.714844 14.53125 6.714844 L 15.46875 6.714844 C 17.246094 6.714844 18.964844 7.082031 20.539062 7.777344 C 20.199219 5.292969 18.074219 3.386719 15.5 3.386719 Z M 15.5 3.386719 " />
            <path d="M 15.878906 8.480469 L 15.878906 29.992188 C 21.636719 29.777344 26.234375 25.054688 26.234375 19.234375 C 26.234375 13.429688 21.644531 8.695312 15.878906 8.480469 Z M 18.765625 25.292969 C 18.28125 25.292969 17.886719 24.898438 17.886719 24.414062 C 17.886719 23.929688 18.28125 23.535156 18.765625 23.535156 C 19.25 23.535156 19.644531 23.929688 19.644531 24.414062 C 19.644531 24.898438 19.25 25.292969 18.765625 25.292969 Z M 18.765625 20.113281 C 18.28125 20.113281 17.886719 19.722656 17.886719 19.234375 C 17.886719 18.75 18.28125 18.355469 18.765625 18.355469 C 19.25 18.355469 19.644531 18.75 19.644531 19.234375 C 19.644531 19.722656 19.25 20.113281 18.765625 20.113281 Z M 18.765625 14.9375 C 18.28125 14.9375 17.886719 14.542969 17.886719 14.058594 C 17.886719 13.574219 18.28125 13.179688 18.765625 13.179688 C 19.25 13.179688 19.644531 13.574219 19.644531 14.058594 C 19.644531 14.542969 19.25 14.9375 18.765625 14.9375 Z M 21.589844 22.46875 C 21.105469 22.46875 20.710938 22.074219 20.710938 21.589844 C 20.710938 21.105469 21.105469 20.710938 21.589844 20.710938 C 22.074219 20.710938 22.46875 21.105469 22.46875 21.589844 C 22.46875 22.074219 22.074219 22.46875 21.589844 22.46875 Z M 21.589844 17.761719 C 21.105469 17.761719 20.710938 17.367188 20.710938 16.882812 C 20.710938 16.398438 21.105469 16.003906 21.589844 16.003906 C 22.074219 16.003906 22.46875 16.398438 22.46875 16.882812 C 22.46875 17.367188 22.074219 17.761719 21.589844 17.761719 Z M 21.589844 17.761719 " />
            <path d="M 3.765625 19.234375 C 3.765625 25.042969 8.355469 29.777344 14.121094 29.992188 L 14.121094 8.480469 C 8.363281 8.695312 3.765625 13.417969 3.765625 19.234375 Z M 11.234375 13.179688 C 11.71875 13.179688 12.113281 13.574219 12.113281 14.058594 C 12.113281 14.542969 11.71875 14.9375 11.234375 14.9375 C 10.75 14.9375 10.355469 14.542969 10.355469 14.058594 C 10.355469 13.574219 10.75 13.179688 11.234375 13.179688 Z M 11.234375 18.355469 C 11.71875 18.355469 12.113281 18.75 12.113281 19.234375 C 12.113281 19.722656 11.71875 20.113281 11.234375 20.113281 C 10.75 20.113281 10.355469 19.722656 10.355469 19.234375 C 10.355469 18.75 10.75 18.355469 11.234375 18.355469 Z M 11.234375 23.535156 C 11.71875 23.535156 12.113281 23.929688 12.113281 24.414062 C 12.113281 24.898438 11.71875 25.292969 11.234375 25.292969 C 10.75 25.292969 10.355469 24.898438 10.355469 24.414062 C 10.355469 23.929688 10.75 23.535156 11.234375 23.535156 Z M 8.410156 16.003906 C 8.894531 16.003906 9.289062 16.398438 9.289062 16.882812 C 9.289062 17.367188 8.894531 17.761719 8.410156 17.761719 C 7.925781 17.761719 7.53125 17.367188 7.53125 16.882812 C 7.53125 16.398438 7.925781 16.003906 8.410156 16.003906 Z M 8.410156 20.710938 C 8.894531 20.710938 9.289062 21.105469 9.289062 21.589844 C 9.289062 22.074219 8.894531 22.46875 8.410156 22.46875 C 7.925781 22.46875 7.53125 22.074219 7.53125 21.589844 C 7.53125 21.105469 7.925781 20.710938 8.410156 20.710938 Z M 8.410156 20.710938 " />
          </svg>
        )
      },
      scan: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 19}
            height={height ? height : 20}
            viewBox="0 0 19 20">
            <g id="Scan" transform="translate(-322 -107)">
              <g
                id="Rectangle_1679"
                className="cls-1"
                stroke="#124b5f"
                strokeWidth="1.3"
                fill="none"
                data-name="Rectangle 1679"
                transform="translate(322.5 108)">
                <rect width="18" height="18" className="cls-3" stroke="none" rx="3" />
                <rect width="16.7" height="16.7" x=".65" y=".65" className="cls-4" fill="none" rx="2.35" />
              </g>
              <path
                id="Line_111"
                d="M0 20V0"
                className="cls-2"
                stroke="#fbf8f1"
                strokeWidth="6"
                fill="none"
                data-name="Line 111"
                transform="translate(331.5 107)"
              />
              <path
                id="Line_112"
                d="M0 0h19"
                className="cls-2"
                stroke="#fbf8f1"
                strokeWidth="6"
                fill="none"
                data-name="Line 112"
                transform="translate(322 117.5)"
              />
              <path
                id="Line_110"
                d="M0 0h18"
                className="cls-1"
                stroke="#124b5f"
                strokeWidth="1.3"
                fill="none"
                data-name="Line 110"
                transform="translate(322.5 117.5)"
              />
            </g>
          </svg>
        )
      },
      close: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 16}
            height={height ? height : 16}
            viewBox="0 0 16 16">
            <g id="Close" transform="translate(-325 -109)">
              <g id="Group_1178" data-name="Group 1178" transform="translate(325 109)">
                <circle
                  id="Ellipse_346"
                  cx="8"
                  cy="8"
                  r="8"
                  className="cls-1"
                  fill="rgba(18,75,95,.4)"
                  data-name="Ellipse 346"
                />
              </g>
              <path
                id="Line_117"
                d="M0 0l6.6 6.6"
                className="cls-2"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                storkemiterlimit="10"
                strokeWidth="1.2"
                data-name="Line 117"
                transform="translate(329.7 113.7)"
              />
              <path
                id="Line_118"
                d="M0 6.6L6.6 0"
                className="cls-2"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                storkemiterlimit="10"
                strokeWidth="1.2"
                data-name="Line 118"
                transform="translate(329.7 113.7)"
              />
            </g>
          </svg>
        )
      },
      closeProduct: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 17.414 17.414"
            width={width ? width : 17.414}
            height={height ? height : 17.414}>
            <g id="Group_1659" data-name="Group 1659" transform="translate(-15.793 -52.793)">
              <path
                id="Line_3"
                d="M0 16L16 0"
                className="cls-1"
                strokeWidth="2"
                fill="none"
                stroke={color ? color : 'none'}
                data-name="Line 3"
                transform="translate(16.5 53.5)"
              />
              <path
                id="Line_119"
                d="M0 0l16 16"
                className="cls-1"
                strokeWidth="2"
                fill="none"
                stroke={color ? color : 'none'}
                data-name="Line 119"
                transform="translate(16.5 53.5)"
              />
            </g>
          </svg>
        )
      },
      closeModal: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 11.98}
            height={height ? height : 11.98}
            viewBox="0 0 11.98 11.98">
            <g id="Close" transform="translate(-332.01 -615.01)">
              <path
                id="Line_105_1_"
                d="M0 10L10 0"
                className="cls-1"
                fill={color ? color : 'none'}
                stroke="#124b5f"
                strokeLinecap="round"
                strokeWidth="1.4px"
                transform="translate(333 616.001)"
              />
              <path
                id="Line_106_1_"
                d="M0 0l10 10"
                className="cls-1"
                fill={color ? color : 'none'}
                stroke="#124b5f"
                strokeLinecap="round"
                strokeWidth="1.4px"
                transform="translate(333 616.001)"
              />
            </g>
          </svg>
        )
      },
      warning: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 12.356}
            height={height ? height : 10.549}
            viewBox="0 0 12.356 10.549">
            <g id="Warining" transform="translate(-124.803 -120.77)">
              <path
                id="bHBuMx.tif_1_"
                d="M12.309 9.361l-.232-.461L6.967.536C6.89.459 6.813.3 6.658.149a.706.706 0 0 0-.929 0 1.359 1.359 0 0 0-.31.387C3.716 3.323 2.013 6.11.232 8.9a.591.591 0 0 0-.155.387.857.857 0 0 0 .7 1.239h10.68c.077 0 .155-.077.232-.077a.8.8 0 0 0 .62-1.088zm-6.116-.232a.464.464 0 0 1 0-.929.5.5 0 0 1 .464.464c.001.236-.232.388-.464.465zm.464-2.477c0 .31-.155.542-.464.542s-.464-.232-.464-.542V3.865a.518.518 0 0 1 .464-.542c.31 0 .464.232.464.542v2.787z"
                className="cls-1"
                fill={color ? color : 'red'}
                transform="translate(124.802 120.796)"
              />
            </g>
          </svg>
        )
      },
      rotateRight: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 14.8}
            height={height ? height : 17.199}
            viewBox="0 0 14.8 17.199">
            <g id="Group_1600" data-name="Group 1600" transform="translate(.4 .891)">
              <path
                fill={color ? color : '#124b5f'}
                stroke={color ? color : '#124b5f'}
                id="Path_1712"
                d="M12.727 8.909a5.727 5.727 0 1 1-11.455 0 5.776 5.776 0 0 1 5.569-5.727v1.909L9.7 2.545 6.841 0v1.909a7 7 0 1 0 7.159 7z"
                className="cls-1"
                data-name="Path 1712"
              />
            </g>
          </svg>
        )
      },
      rotateLeft: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 14.8}
            height={height ? height : 17.199}
            viewBox="0 0 14.8 17.199">
            <g id="Group_1602" data-name="Group 1602" transform="translate(.4 .891)">
              <g id="Reload_2_">
                <g id="Group_1600" data-name="Group 1600">
                  <path
                    fill={color ? color : '#124b5f'}
                    stroke={color ? color : '#124b5f'}
                    id="Path_1712"
                    d="M1.273 8.909a5.727 5.727 0 0 0 11.455 0 5.776 5.776 0 0 0-5.569-5.727v1.909L4.3 2.545 7.159 0v1.909a7 7 0 1 1-7.159 7z"
                    className="cls-1"
                    data-name="Path 1712"
                  />
                </g>
              </g>
            </g>
          </svg>
        )
      },
      edit: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16.028 15.729"
            width={width ? width : 16.028}
            height={height ? height : 15.729}>
            <g id="edit" transform="translate(-5.6 -6.9)">
              <path
                id="Path_1660"
                d="M21.143 114.3H6.258a.568.568 0 0 0-.558.573.577.577 0 0 0 .558.573h14.9a.568.568 0 0 0 .558-.573.58.58 0 0 0-.573-.573z"
                className="cls-1"
                fill={color ? color : '#fff'}
                data-name="Path 1660"
                transform="translate(-.086 -92.816)"
              />
              <path
                id="Path_1661"
                d="M5.614 16.83L5.6 19.553a.591.591 0 0 0 .168.419.559.559 0 0 0 .405.168l2.709-.014a.559.559 0 0 0 .405-.168l9.357-9.358a.59.59 0 0 0 0-.824l-2.682-2.708a.59.59 0 0 0-.824 0l-1.871 1.885-7.485 7.472a.622.622 0 0 0-.168.405zm9.943-8.53l1.885 1.885-1.061 1.061L14.5 9.358zm-8.784 8.781l6.9-6.9 1.885 1.885-6.9 6.885-1.9.014z"
                className="cls-1"
                fill={color ? color : '#fff'}
                data-name="Path 1661"
              />
            </g>
          </svg>
        )
      },
      spread: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 20.291}
            height={height ? height : 15.789}
            viewBox="0 0 20.291 15.789">
            <g id="Group_1563" data-name="Group 1563" transform="translate(.1 .099)">
              <path
                id="Path_1674"
                d="M13.928 4.325a3.6 3.6 0 0 1-.466 1.785A3.694 3.694 0 0 1 10.2 8.05a3.818 3.818 0 0 1-3.334-1.94A3.215 3.215 0 0 1 6.4 4.325 3.726 3.726 0 0 1 10.125.6a3.845 3.845 0 0 1 3.803 3.725z"
                className="cls-1"
                fill="none"
                stroke="#124b5f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit={10}
                strokeWidth="1.4px"
                data-name="Path 1674"
                transform="translate(-1.299)"
              />
              <path
                id="Path_1675"
                d="M12.474 15.176H.6A11.385 11.385 0 0 1 3.937 9.2"
                className="cls-1"
                fill="none"
                stroke="#124b5f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit={10}
                strokeWidth="1.4px"
                data-name="Path 1675"
                transform="translate(0 -1.926)"
              />
              <path
                id="Path_1676"
                d="M11.2 9.74a3.694 3.694 0 0 0 3.259-1.94 9.487 9.487 0 0 1 2.561 2.1"
                className="cls-2"
                strokeWidth="1.4px"
                data-name="Path 1676"
                transform="translate(-2.374 -1.612)"
                fill="#fff"
                stroke="#124b5f"
              />
              <circle
                id="Ellipse_384"
                cx="3.104"
                cy="3.104"
                r="3.104"
                className="cls-3"
                data-name="Ellipse 384"
                transform="translate(13.483 8.981)"
                fill="#fff"
                stroke="#124b5f"
              />
              <g id="Group_1562" data-name="Group 1562" transform="translate(14.957 10.378)">
                <g id="Group_1561" data-name="Group 1561">
                  <path
                    id="Path_1677"
                    d="M20.519 16.559v-1.4H19.2V14.7h1.319v-1.4h.543v1.4h1.319v.466h-1.318v1.4z"
                    className="cls-4"
                    fill={color ? color : '#124b5f'}
                    data-name="Path 1677"
                    transform="translate(-19.122 -13.222)"
                  />
                  <path
                    id="Path_1678"
                    d="M20.963 13.355v1.4h1.319v.388h-1.319v1.4h-.388v-1.4h-1.32v-.388h1.319v-1.4h.388m.155-.155h-.7v1.4H19.1v.7h1.319v1.4h.7v-1.4h1.319v-.7h-1.32v-1.4z"
                    className="cls-4"
                    fill={color ? color : '#124b5f'}
                    data-name="Path 1678"
                    transform="translate(-19.1 -13.2)"
                  />
                </g>
              </g>
            </g>
          </svg>
        )
      },
      location: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 19.4 18.6"
            width={width ? width : 19.4}
            height={height ? height : 18.6}>
            <g id="Group_1560" data-name="Group 1560" transform="translate(.1 -.001)">
              <path
                id="Path_1669"
                d="M14.6 12.4c2.4.5 4 1.4 4 2.5 0 1.6-4 3-9 3s-9-1.3-9-3c0-1 1.5-1.9 3.9-2.4"
                className="cls-1"
                fill="none"
                stroke="#124b5f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit={10}
                strokeWidth="1.2px"
                data-name="Path 1669"
              />
              <path
                id="Path_1672"
                d="M14.6 12.4c2.4.5 4 1.4 4 2.5 0 1.6-4 3-9 3s-9-1.3-9-3c0-1 1.5-1.9 3.9-2.4"
                className="cls-2"
                fill="none"
                stroke="#124b5f"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit={10}
                strokeWidth="1.4px"
                data-name="Path 1672"
              />
              <g id="Group_1559" data-name="Group 1559">
                <path
                  id="Path_1670"
                  d="M9.5 0a6.061 6.061 0 0 0-6.1 6.1c0 5 5.5 9.4 5.8 9.6.1.1.2.1.4.1a.6.6 0 0 0 .4-.1c.2-.2 5.8-4.6 5.8-9.6A6.366 6.366 0 0 0 9.5 0zm0 14.5c-1.2-1-5-4.6-5-8.4a5.015 5.015 0 0 1 5-5 4.951 4.951 0 0 1 5 5c0 3.8-3.8 7.4-5 8.4z"
                  className="cls-3"
                  fill={color ? color : '#124b5f'}
                  data-name="Path 1670"
                />
                <path
                  id="Path_1671"
                  d="M9.5 3.1a2.8 2.8 0 0 0 .1 5.6 2.734 2.734 0 0 0 2.8-2.8 3.025 3.025 0 0 0-2.9-2.8zm0 4.4a1.6 1.6 0 1 1 1.6-1.6 1.58 1.58 0 0 1-1.6 1.6z"
                  className="cls-3"
                  fill={color ? color : '#124b5f'}
                  data-name="Path 1671"
                />
              </g>
            </g>
          </svg>
        )
      },
      feedback: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 19.245 14.975"
            width={width ? width : 19.245}
            height={height ? height : 14.975}>
            <path
              id="Path_1673"
              d="M17.082 0H1.667A1.645 1.645 0 0 0 0 1.667v6.978a1.645 1.645 0 0 0 1.667 1.667h1.458v3.75c0 .1.1.312.208.312h.1a.383.383 0 0 0 .312-.1l3.541-3.958h9.687a1.645 1.645 0 0 0 1.667-1.667V1.667a2.164 2.164 0 0 0-.521-1.25A1.591 1.591 0 0 0 17.082 0zm.937 8.645a.934.934 0 0 1-.937.937h-9.9a.383.383 0 0 0-.312.1L3.75 13.02V9.9a.333.333 0 0 0-.312-.312H1.667a.934.934 0 0 1-.937-.937V1.667A1.028 1.028 0 0 1 1.667.625h15.415a.962.962 0 0 1 .937 1.042zM3.437 3.229h5.729a.333.333 0 0 0 .312-.312c0-.1 0-.312-.208-.312H3.437a.333.333 0 0 0-.312.312.333.333 0 0 0 .312.312zm11.875 1.354H3.437A.465.465 0 0 0 3.125 5a.333.333 0 0 0 .312.312h11.77c.208 0 .417-.1.417-.312a.465.465 0 0 0-.312-.417zm0 2.083H3.437a.312.312 0 0 0 0 .625h11.77a.333.333 0 0 0 .312-.312c.001-.104-.103-.313-.207-.313z"
              className="cls-1"
              data-name="Path 1673"
              transform="translate(.3 .301)"
              fill={color ? color : '124b5f'}
              stroke="#124b5f"
              strokeWidth="0.6px"
            />
          </svg>
        )
      },
      addToList: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 20}
            height={height ? height : 12}
            viewBox="0 0 20 12">
            <g id="BIg_add-to-list" data-name="BIg@add-to-list" transform="translate(-233 -396)">
              <path
                id="Path_1648"
                d="M16.617 1.436H.7A.691.691 0 0 1 0 .718.691.691 0 0 1 .7 0h15.92a.691.691 0 0 1 .7.718.691.691 0 0 1-.703.718zM.7 5.128a.718.718 0 0 0 0 1.436h9.751a3.654 3.654 0 0 1 .6-1.436H.7zm9.751 5.128H.7a.718.718 0 0 0 0 1.436h9.95a.359.359 0 0 0 .3-.1zM19.4 7.692h-2.385V5.231a.6.6 0 1 0-1.194 0v2.461h-2.388a.616.616 0 0 0 0 1.231h2.388v2.462a.6.6 0 1 0 1.194 0V8.923H19.4a.616.616 0 0 0 0-1.231z"
                className="cls-1"
                fill={color ? color : '#124b5f'}
                data-name="Path 1648"
                transform="translate(233 396)"
              />
            </g>
          </svg>
        )
      },
      distance: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 10}
            height={height ? height : 10}
            viewBox="0 0 10 10">
            <path
              id="Icon"
              d="M0 4.545h5.556V10L10 0z"
              fillRule="evenodd"
              className="cls-1"
              fill={color ? color : '#00aada'}
            />
          </svg>
        )
      },
      addToCart: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Group_1629"
            data-name="Group 1629"
            viewBox="0 0 24.002 21"
            width={width ? width : 24.002}
            height={height ? height : 21}>
            <circle
              id="Ellipse_394"
              cx="2.4"
              cy="2.4"
              r="2.4"
              fill={color ? color : '#fff'}
              className="cls-1"
              data-name="Ellipse 394"
              transform="translate(7.54 16.2)"
            />
            <circle
              id="Ellipse_395"
              cx="2.4"
              cy="2.4"
              r="2.4"
              fill={color ? color : '#fff'}
              className="cls-1"
              data-name="Ellipse 395"
              transform="translate(18.056 16.2)"
            />
            <path
              id="Path_1704"
              d="M0 1h4.6l1.9 4.6"
              fill={color ? color : '#fff'}
              className="cls-2"
              strokeMiterlimit="10"
              strokeWidth="2px"
              data-name="Path 1704"
            />
            <g id="Group_1628" data-name="Group 1628" transform="translate(5.056 2.1)">
              <path
                id="Path_1705"
                d="M8.7 14.3a.664.664 0 0 1-.5-.4L5.9 4.6l15.3-1.4h.3a.55.55 0 0 1 .5.3l.4 4.2v.2a.6.6 0 0 1-.1.4c-.1.1-.2.2-.3.2h-.1L8.7 14.3z"
                fill={color ? color : '#fff'}
                className="cls-1"
                data-name="Path 1705"
                transform="translate(-4.7 -2.1)"
              />
              <path
                id="Path_1706"
                d="M21.099999999999998 4.199999999999999l.4 3.5L9 13.1 7.2 5.5l13.9-1.3m.5-2.1a.6.6 0 0 0-.4.1L4.7 3.7l2.5 10.5a1.5 1.5 0 0 0 1.5 1.1.6.6 0 0 0 .4-.1l13.4-5.8a1.6 1.6 0 0 0 1.1-1.9l-.4-4.3a1.878 1.878 0 0 0-1.6-1.1z"
                fill={color ? color : '#fff'}
                className="cls-1"
                data-name="Path 1706"
                transform="translate(-4.7 -2.1)"
              />
            </g>
          </svg>
        )
      },
      share: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18.096 24.1"
            width={width ? width : 18.096}
            height={height ? height : 24.1}>
            <path
              id="KEgvnj.tif_1_"
              d="M8.948 24h7.105a2.389 2.389 0 0 0 .532-.045 1.894 1.894 0 0 0 1.367-1.914V7.859a1.662 1.662 0 0 0-1.66-1.81c-1-.025-2-.01-3 0a.9.9 0 0 0-.864.6.866.866 0 0 0 .855 1.16c.791.01 1.577 0 2.368 0 .43 0 .571.144.571.575v13.092c0 .367-.1.471-.464.476H2.229c-.449 0-.537-.089-.537-.531V8.4c0-.466.132-.6.6-.6.767 0 1.529.01 2.3 0a.885.885 0 0 0 .894-1.18.9.9 0 0 0-.923-.59H1.804A1.708 1.708 0 0 0-.042 7.9v14.133A1.814 1.814 0 0 0 1.892 24zM8.084 3.124v11.415a1.832 1.832 0 0 0 .034.367.866.866 0 0 0 .816.694.846.846 0 0 0 .85-.645 2.206 2.206 0 0 0 .049-.54V3.362a.921.921 0 0 1 .01-.134c.518.5 1.06 1.007 1.592 1.532a.925.925 0 1 0 1.309-1.3Q11.2 1.892 9.651.322a.906.906 0 0 0-1.382 0Q6.724 1.879 5.178 3.456a.951.951 0 0 0-.054 1.354.916.916 0 0 0 1.314-.064c.479-.471.952-.947 1.431-1.423a2.481 2.481 0 0 1 .215-.199zM8.948 24h7.105a2.389 2.389 0 0 0 .532-.045 1.894 1.894 0 0 0 1.367-1.914V7.859a1.662 1.662 0 0 0-1.66-1.81c-1-.025-2-.01-3 0a.9.9 0 0 0-.864.6.866.866 0 0 0 .855 1.16c.791.01 1.577 0 2.368 0 .43 0 .571.144.571.575v13.092c0 .367-.1.471-.464.476H2.229c-.449 0-.537-.089-.537-.531V8.4c0-.466.132-.6.6-.6.767 0 1.529.01 2.3 0a.885.885 0 0 0 .894-1.18.9.9 0 0 0-.923-.59H1.804A1.708 1.708 0 0 0-.042 7.9v14.133A1.814 1.814 0 0 0 1.892 24zM8.084 3.436v11.1a1.832 1.832 0 0 0 .034.367.866.866 0 0 0 .816.694.846.846 0 0 0 .85-.645 2.206 2.206 0 0 0 .049-.54V3.362a.921.921 0 0 1 .01-.134c.518.5 1.06 1.007 1.592 1.532a.925.925 0 1 0 1.309-1.3Q11.2 1.892 9.651.322a.906.906 0 0 0-1.382 0Q6.724 1.879 5.178 3.456a.951.951 0 0 0-.054 1.354.916.916 0 0 0 1.314-.064c.479-.471.952-.947 1.431-1.423.054-.055.117-.1.215-.193v.306z"
              fill={color ? color : '#fff'}
              stroke="#124b5f"
              strokeWidth="0.1px"
              className="cls-1"
              transform="translate(.093 .051)"
            />
          </svg>
        )
      },
      suggestion: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22 13.2"
            width={width ? width : 22}
            height={height ? height : 13.2}>
            <path
              id="Path_1707"
              d="M15.4 0l2.53 2.53-5.39 5.39-4.4-4.4L0 11.66l1.54 1.54 6.6-6.6 4.4 4.4 6.93-6.93L22 6.6V0z"
              fill={color ? color : '#a0b7bf'}
              className="cls-1"
              data-name="Path 1707"
            />
          </svg>
        )
      },
      default: () => {
        return (
          <svg
            fill={color ? color : '#cccccc'}
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z" />
          </svg>
        )
      }
    }
    return svg[icon || 'default']()
  }
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon.js